<template>
  <div>
    <div
      class="fe-text-body-xs fe-text-primary-grey-100 lg:fe-text-body-m-bold fe-mb-xs lg:fe-mb-s"
    >
      Q. {{ questionData.question }}
    </div>
    <div>
      <div v-if="answerData?.answer" class="fe-flex fe-items-center">
        <UserInitialsAvatar :name="answerData.customerName" />

        <div
          class="fe-text-body-xxs-bold lg:fe-text-body-s-bold fe-mx-xs lg:fe-ml-xs lg:fe-mr-s"
        >
          {{ answerData.customerName }}
        </div>

        <div
          class="fe-flex fe-items-center fe-gap-xxxs fe-text-primary-grey-60 fe-text-body-xxs"
        >
          <JdsIcon
            name="SuccessIcon"
            size="s"
            color="fe-text-primary-grey-60"
          />
          <span class="sm:fe-hidden">Verified User</span
          ><span class="lg:fe-hidden">Verified user</span>
        </div>
      </div>
      <div
        v-if="answerData?.answer"
        class="fe-ml-l fe-text-primary-grey-80 fe-text-body-xxs lg:fe-text-body-xs"
      >
        A. {{ answerData.answer }}
      </div>
      <div
        class="fe-ml-l fe-mt-s fe-mb-m lg:fe-mt-base lg:fe-mb-xxl fe-flex fe-items-center sm:fe-justify-between"
      >
        <QnAVote
          v-if="answerData?.answer"
          :answer="answerData"
          :disabled="isAnswerCreatedBySameUser"
          class="fe-mr-base"
        />
        <div v-if="questionData.numberOfAnswers > 1">
          <JdsLink
            type="button"
            @click="openAnswerModalWithoutCheckPurchase"
            class-name="sm:fe-text-body-xxs-link"
          >
            +{{ questionData.numberOfAnswers - 1 }} more answers
          </JdsLink>
        </div>
        <div v-else>
          <CustomFdkAccount
            v-slot="accountsData"
            v-if="!isAnswerCreatedBySameUser"
          >
            <JdsLink
              type="button"
              @click="openAnswerModal(accountsData)"
              class-name="sm:fe-text-body-xxs-link"
              :disabled="isQuestionCreatedBySameUser"
            >
              Contribute and Answer
            </JdsLink>
          </CustomFdkAccount>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import JdsLink from "@/components/DesignSystem/JdsLink/JdsLink.vue"
  import UserInitialsAvatar from "@/components/QuestionAndAnswer/UserInitialsAvatar/UserInitialsAvatar.vue"
  import QnAVote from "@/components/QuestionAndAnswer/QnAVote/QnAVote.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import { toastMixin } from "@/mixins/toastMixin"
  import { modalMixin } from "@/mixins/modalMixin"
  import AnswerDialog from "@/components/QuestionAndAnswer/AnswerDialog/AnswerDialog.vue"

  export default {
    name: "AllQnAList",
    components: {
      UserInitialsAvatar,
      JdsLink,
      JdsIcon,
      QnAVote,
      CustomFdkAccount,
    },
    inject: ["globalState", "checkVerifiedPurchase"],
    mixins: [toastMixin, modalMixin],
    props: {
      qna: {
        type: Object,
        default: () => ({}),
        required: true,
      },
    },
    computed: {
      answerData() {
        return this.qna.answers?.[0]
      },
      questionData() {
        return this.qna.question
      },
      isQuestionCreatedBySameUser() {
        return this.globalState.user.user_id === this.questionData?.createdBy
      },
      isAnswerCreatedBySameUser() {
        return this.globalState.user.user_id === this.answerData?.createdBy
      },
    },
    methods: {
      openAnswerModalWithoutCheckPurchase() {
        this.openDialog(AnswerDialog, {
          qna: this.qna,
        })
      },
      async openAnswerModal(accountsData) {
        if (!accountsData?.is_logged_in) {
          accountsData.openLogin()

          return
        }

        const isUserAllowedToAnswer = await this.checkVerifiedPurchase()

        if (isUserAllowedToAnswer) {
          this.openDialog(AnswerDialog, {
            qna: this.qna,
          })
        } else {
          this.showToast({
            message:
              "In order to answer the Question for this product, you must first purchase it. Thank you for your understanding",
            type: "none",
            keepPreviousToastIfSame: true,
          })
        }
      },
    },
  }
</script>
